import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createTimeTrackingActivityEntityInfo } from 'record-it-time-common/entity/entities/TimeTrackingActivity/createTimeTrackingActivityEntityInfo';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';
import { TimeTrackingActivity } from './timeTrackingActivityTypes';
export const timeTrackingActivityEntityInfo = createTimeTrackingActivityEntityInfo<TimeTrackingActivity>({
  additionalFieldInfos: EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
});